import React from 'react';
import type { ReactNode } from 'react';
import styles from './FormSection.module.scss';

interface FormSectionProps {
  /** Шаги нумеруем, потому что форму заполняют сверху вниз и порядок несёт смысл. */
  step: number;
  title: string;
  optional?: boolean;
  children: ReactNode;
}

export function FormSection({ step, title, optional, children }: FormSectionProps) {
  return (
    <section className={styles.section}>
      <header className={styles.head}>
        <span className={styles.num}>{step}</span>
        <b>{title}</b>
        {optional && <span>— необязательно</span>}
      </header>
      {children}
    </section>
  );
}
